import { render, staticRenderFns } from "./PayersFilterDropdown.vue?vue&type=template&id=630b0579&scoped=true"
import script from "./PayersFilterDropdown.vue?vue&type=script&lang=js"
export * from "./PayersFilterDropdown.vue?vue&type=script&lang=js"
import style0 from "./PayersFilterDropdown.vue?vue&type=style&index=0&id=630b0579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b0579",
  null
  
)

export default component.exports